// Shared formatting helpers — keep display logic out of components.

export const money = (n: number): string =>
  n === 0 ? "$0" : `$${Math.round(n).toLocaleString("en-US")}`;

export const compactMoney = (n: number): string => {
  if (n >= 1000) return `$${(n / 1000).toFixed(1)}k`;
  return money(n);
};

export const secs = (total: number): string => {
  const m = Math.floor(total / 60);
  const s = Math.round(total % 60);
  return m ? `${m}m ${s}s` : `${s}s`;
};

export const pct = (n: number, digits = 1): string => `${n.toFixed(digits)}%`;

/** "3m ago" / "2h ago" / "5d ago" — coarse enough for a notification feed. */
export function timeAgo(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const diffSec = Math.max(0, Math.round((Date.now() - then) / 1000));
  if (diffSec < 60) return "just now";
  const diffMin = Math.round(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.round(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.round(diffHr / 24);
  return `${diffDay}d ago`;
}

export type ValueFormat = "money" | "compactMoney" | "secs" | "pct" | "int" | "num";

export function formatValue(raw: number, fmt: ValueFormat): string {
  switch (fmt) {
    case "money":
      return money(raw);
    case "compactMoney":
      return compactMoney(raw);
    case "secs":
      return secs(raw);
    case "pct":
      return pct(raw);
    case "int":
      return Math.round(raw).toLocaleString("en-US");
    case "num":
      return raw.toFixed(1);
  }
}
